import { intFormatter, tibFormatter } from '@/utils/number-formatters';

const GIB_PER_TIB = 1024;

export function formatGib(gib: number): string {
  if (gib >= GIB_PER_TIB) {
    return `${tibFormatter.format(gib / GIB_PER_TIB)} TiB`;
  }
  return `${intFormatter.format(gib)} GiB`;
}
